import React from "react";
import "./contactPage.css";

const ContactPage = () => {
	return (
		<div className="contact-page">
			<h1 className="page-title">Contact Me</h1>
			<div className="contact-container ">
				<div className="contact-item outer-item">
					<i className="fa-solid fa-envelope contact-icon"></i>
					<span className="contact-title">Email</span>
					<span className="contact-content">
						Claudenij2@gmail.com
					</span>
				</div>
				<div className="contact-item ">
					<i className="fa-brands fa-linkedin contact-icon"></i>
					<span className="contact-title">LinkedIn</span>
					<span className="contact-content">
						<a
							className="link"
							href="https://www.linkedin.com/in/claude-nijem/"
							rel="noreferrer"
							target="_blank"
						>
							Claude Nijem
						</a>
					</span>
				</div>
				<div className="contact-item outer-item">
					<i className="fa-brands fa-github contact-icon"></i>
					<span className="contact-title">Github</span>
					<span className="contact-content">
						<a
							className="link"
							href="https://github.com/ClaudeNi"
							rel="noreferrer"
							target="_blank"
						>
							ClaudeNi
						</a>
					</span>
				</div>
			</div>
		</div>
	);
};

export default ContactPage;
